import { render } from "./DTableCell.vue?vue&type=template&id=bae783da&scoped=true&lang=pug"
import script from "./DTableCell.vue?vue&type=script&lang=js"
export * from "./DTableCell.vue?vue&type=script&lang=js"

import "./DTableCell.vue?vue&type=style&index=0&id=bae783da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae783da"]])

export default __exports__